module.exports = __webpack_public_path__ + "img/opera.545cf86d.svg";